export const filter = {
            id:  "",
        
            file:  "",
};
